import { Actions, ModalDialog } from 'core-components/library/modalDialog'

interface IConfirmationDialogProps {
  confirmationDialog: boolean
  changeStatus: boolean
  changeConfirmationDialog: () => void
  onSaveStatus: () => Promise<void>
  onRemoveRequest: () => Promise<void>
}

export const ConfirmationDialog = ({
  confirmationDialog,
  changeStatus,
  changeConfirmationDialog,
  onSaveStatus,
  onRemoveRequest,
}: IConfirmationDialogProps) => {
  const onClose = () => {
    changeConfirmationDialog()
  }

  const onYes = () => {
    if (changeStatus) {
      onSaveStatus()
    } else {
      onRemoveRequest()
    }
  }

  return (
    <ModalDialog
      show={confirmationDialog}
      onClose={onClose}
      size={'sm'}
      content={() => (
        <p style={{ lineHeight: 1.4, textAlign: 'center' }}>
          {changeStatus
            ? 'Please note this will fully inactivate this contact. Are you sure you want to proceed?'
            : 'Are you sure you want to remove the request?'}
        </p>
      )}
      footer={() => (
        <Actions
          position={'end'}
          items={[
            {
              id: 'delete',
              color: 'danger',
              variant: 'outlined',
              label: changeStatus ? 'Apply' : 'Remove Request',
              onClick: onYes,
            },
            {
              id: 'cancel',
              label: 'Cancel',
              variant: 'outlined',
              onClick: onClose,
            },
          ]}
        />
      )}
    />
  )
}
